// extracted by mini-css-extract-plugin
export default {"chart_box":"EnergySavingPie_chart_box__DCwYX","spin_box":"EnergySavingPie_spin_box__ond3O","empty_box":"EnergySavingPie_empty_box__dWbEa"};